import { Box } from '@mui/material';
import React from 'react';
import {
  BooleanField,
  Datagrid,
  EditButton,
  FunctionField,
  NumberField,
  ShowButton,
  TextField,
} from 'react-admin';
import useCanWrite from '../../../hooks/useCanWrite';
import useIsExerciseEditor from '../../../hooks/useIsExerciseEditor';
import { nameColumnStyling } from '../../../utils/nameFieldSx';
import InfiniteList from '../components/InfiniteList';
import {
  ArchiveResourceButton,
  actionsHeaderLabel,
  rowActionsSx,
} from './CategoryActions';
import { ExerciseFilters } from './filters';

export type ExerciseTabListProps = {
  filterDefaultValues?: Record<string, unknown>;
  disableSyncWithLocation?: boolean;
};

export const ExerciseRecordsList: React.FC<ExerciseTabListProps> = ({
  filterDefaultValues,
  disableSyncWithLocation = true,
}) => {
  const isExerciseEditor = useIsExerciseEditor();
  const canWrite = useCanWrite();
  const canModifyExercise = canWrite || isExerciseEditor;

  return (
    <InfiniteList
      disableSyncWithLocation={disableSyncWithLocation}
      filters={<ExerciseFilters />}
      filterDefaultValues={filterDefaultValues}
      sort={{ field: 'createdAt', order: 'DESC' }}
    >
      <Datagrid
        bulkActionButtons={false}
        sx={{
          '& td.column-name': nameColumnStyling,
          '& td.column-displayName': nameColumnStyling,
        }}
      >
        <TextField source="name" sortable sx={nameColumnStyling} />
        <TextField
          source="displayName"
          sortable={false}
          sx={nameColumnStyling}
        />
        <TextField
          source="exerciseBase.name"
          label="Base Movement"
          sortable={false}
        />
        <TextField
          source="exerciseBase.exerciseType.name"
          label="Movement Type"
          sortable={false}
        />
        <TextField
          source="exerciseBase.exerciseType.exerciseTypeCategory.name"
          label="MTC"
          sortable={false}
        />
        <TextField
          source="exerciseBase.exerciseType.exerciseTypeCategory.exerciseTypeCategoryGroup.name"
          label="MTC Group"
          sortable={false}
        />
        <BooleanField source="canTrackWeight" sortable={false} />
        <TextField
          source="defaultUnit.name"
          label="Default Unit"
          sortable={false}
        />
        <NumberField source="progression" sortable={false} />
        <FunctionField
          label={actionsHeaderLabel}
          sortable={false}
          render={() => (
            <Box sx={rowActionsSx}>
              {canModifyExercise && <EditButton />}
              <ShowButton />
              {canModifyExercise && (
                <ArchiveResourceButton resource="Exercise" />
              )}
            </Box>
          )}
        />
      </Datagrid>
    </InfiniteList>
  );
};

export const ExerciseList: React.FC = () => (
  <Box marginTop={2}>
    <ExerciseRecordsList disableSyncWithLocation={false} />
  </Box>
);
